import {
    FlexResetPeriod,
    FlexResetPeriodCode,
} from '@enums/account/resetPeriods';

export const ResetPeriod = (code: string) => {
    if (code == null) return;
    switch (code) {
        case FlexResetPeriodCode.P1W:
            return FlexResetPeriod.WEEKLY;
        case FlexResetPeriodCode.P1M:
            return FlexResetPeriod.MONTHLY;
        case FlexResetPeriodCode.P1D:
            return FlexResetPeriod.DAILY;
    }
    console.warn(`warning, unable to map code: ${code} to a reset period`);
};

export const ResetPeriodCode = (period: string) => {
    if (period == null) return;
    switch (period) {
        case FlexResetPeriod.MONTHLY:
            return FlexResetPeriodCode.P1M;
        case FlexResetPeriod.WEEKLY:
            return FlexResetPeriodCode.P1W;
        case FlexResetPeriod.DAILY:
            return FlexResetPeriodCode.P1D;
    }
    console.warn(`warning, unable to map period: ${period} to a reset code`);
};
